// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"8afea177","876":"6ddabe65"}[chunkId] + ".chunk.js";
};